import { createApiClient } from '@edv-next/contracts/api-client';
import { getOrCreateWebDeviceId } from './device-id.js';

let accessJwt: string | null = null;
export function setAccessJwt(v: string | null) {
  accessJwt = v;
}
export function getAccessJwt() {
  return accessJwt;
}

// Vite provides `import.meta.env` at build time; typings come from the
// ambient `vite/client` reference loaded via apps/web/tsconfig.json.
// We deliberately do NOT redeclare `ImportMeta` / `ImportMetaEnv` here —
// re-declaring them clashes with the ambient shape shipped by Vite.
// Falls back to empty string (same-origin) when the env var is absent,
// which is the shape used by vitest and same-origin preprod builds.
const configuredBase: string | undefined = import.meta.env.VITE_API_BASE_URL;
export const API_BASE_URL: string =
  typeof configuredBase === 'string' && configuredBase.length > 0
    ? configuredBase
    : '';

export const api = createApiClient({
  baseUrl: API_BASE_URL,
  clientKind: 'web',
  getAccessJwt,
  getDeviceId: getOrCreateWebDeviceId,
});
